import Papa from 'papaparse';

export interface ProjectDetail {
    id: number,
    project_name: string,
    product_type: string,
    submitted_to: string,
    project_number: string,
    prepared_by: string,
    email: string,
    phone_number: number,
    date: string,
    status: string,
    product_size: string,
    project_id: number,
    name: string,
    description: string,
    filename: string,
    url: string,
    type: string,
    sort_order: number,
    active: boolean
};

export interface ProjectWithDocuments {
    id: number;
    project_name: string;
    product_type: string;
    submitted_to: string;
    project_number: string;
    prepared_by: string;
    email: string;
    phone_number: number;
    date: string;
    status: string;
    product_size: string;
    documents: Array<{
        id: number;
        name: string;
        description: string;
        filename: string;
        url: string;
        type: string;
        sort_order: number;
        active: boolean;
    }>;
}

export interface ProjectFormData {
    project_name: string;
    product_type?: string;
    submitted_to: string;
    project_number?: string;
    prepared_by: string;
    email: string;
    phone_number: string | number;
    date: string;
    status: string;
    product_size?: string;
}

class ExportDocumentService {

    private d1Url: string;

    constructor() {
        this.d1Url = import.meta.env.VITE_D1_URL || 'http://localhost:8788'
    }

    async getProjectDetail(

    ) {
        const response = await fetch(`${this.d1Url}/api/get-all-project`);
        
        if(!response.ok){
            alert('Failed to get data!');
        }

        const data: ProjectDetail[] = await response.json();

        return data;
    }

    async exportDocuments(
        productDetails: ProjectDetail[]
    ) {

        const csv = Papa.unparse(productDetails, {
            quotes: true,
            header: true,
            skipEmptyLines: true
        });
    
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
    
        const a = document.createElement('a');
        a.href = url;
        a.download = 'data.csv';
        document.body.appendChild(a);
        a.click();
    
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    async exportProjects(
        projects: Array<{
            id: number;
            project_name: string;
            product_type: string;
            submitted_to: string;
            project_number: string;
            prepared_by: string;
            email: string;
            phone_number: number;
            date: string;
            status: string;
            product_size: string;
            documents_count: number;
        }>
    ) {
        const csv = Papa.unparse(projects, {
            quotes: true,
            header: true,
            skipEmptyLines: true
        });
    
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
    
        const a = document.createElement('a');
        a.href = url;
        a.download = 'projects.csv';
        document.body.appendChild(a);
        a.click();
    
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    async createProject(projectData: ProjectFormData): Promise<ProjectWithDocuments> {
        const response = await fetch(`${this.d1Url}/api/create-project`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(projectData)
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to create project');
        }

        return await response.json();
    }

    async updateProject(id: number, projectData: Partial<ProjectFormData>): Promise<ProjectWithDocuments> {
        const response = await fetch(`${this.d1Url}/api/update-project/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(projectData)
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to update project');
        }

        return await response.json();
    }

    async deleteProject(id: number): Promise<void> {
        const response = await fetch(`${this.d1Url}/api/delete-project/${id}`, {
            method: 'DELETE',
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to delete project');
        }
    }

    async getProjectById(id: number): Promise<ProjectWithDocuments> {
        const response = await fetch(`${this.d1Url}/api/get-project/${id}`);

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to get project');
        }

        return await response.json();
    }
}

export const exportDocumentService = new ExportDocumentService;